/* eslint-disable @typescript-eslint/ban-ts-comment */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { getAnonymousID } from 'redline-client-sdk';
import { useLocation } from 'react-router-dom';
import { GoogleEvent } from './type';

const standardFirebaseEvents = ['purchase'];

export const useGoogleAnalytics = () => {
  const location = useLocation();

  const trackGoogle = (event: GoogleEvent): void => {
    try {
      const isDebtSimulated = event.eventName === 'user_authenticated_with_debt';
      const isNegativeDebtSimulated = event.eventName === 'user_authenticated_with_negative_debt';
      const shouldDispatchBothContainers = isDebtSimulated || isNegativeDebtSimulated;

      // @ts-ignore
      if (window?.isNativeApp) {
        let finalEventName;

        if (standardFirebaseEvents.includes(event.eventName)) {
          finalEventName = event.eventName;
        } else {
          finalEventName = `app_${
            event.eventName
              .replace(/[^a-zA-Z0-9_]/g, '_') // Replace non-alphanumeric/underscore with _
              .replace(/_{2,}/g, '_') // Replace multiple underscores with single
              .replace(/^_+|_+$/g, '') // Trim leading/trailing underscores
          }`;
        }

        if (finalEventName.length > 40) {
          console.error(`${finalEventName} exceeds 40 characters, won't be sent to Firebase Analytics`);
        } else {
          // @ts-ignore
          window?.bridge?.analyticsFirebaseLogEvent(finalEventName, event.payload || {});
        }
        if (!shouldDispatchBothContainers) return;
      }

      if (!window?.gtag) {
        return;
      }

      const anonymousId = getAnonymousID();
      const url = location.pathname;
      const safePayload = event.payload ? { ...event.payload, anonymousId, url } : { anonymousId, url };

      switch (event.target) {
        case 'gA4': {
          window.gtag('event', event.eventName, safePayload);
          break;
        }

        case 'gADS': {
          const gadsPayload = { ...safePayload, send_to: event.conversionId };
          window.gtag('event', 'conversion', gadsPayload);
          break;
        }

        case 'gALL': {
          window.gtag('event', event.eventName, safePayload);

          const universalAdsPayload = { ...safePayload, send_to: event.conversionId };
          window.gtag('event', 'conversion', universalAdsPayload);
          break;
        }

        default: {
          console.error('Unknown Google event target');
          break;
        }
      }
    } catch (error) {
      console.error('Error tracking Google event:', error);
    }
  };

  return { trackGoogle };
};
